var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable:max-classes-per-file variable-name forin */
import * as React from "react";
import Header from "./Header";
import Players from "./Players";
import LabeledPlay from "./LabeledPlay";
import BeepButton from "./BeepButton";
import BidArea from "./BidArea";
import InlineCard from "./InlineCard";
import { translate as t } from "./i18n";
var Draw = /** @class */ (function (_super) {
    __extends(Draw, _super);
    function Draw(props) {
        var _this = _super.call(this, props) || this;
        _this.could_draw = false;
        _this.timeout = null;
        _this.drawCardAudio = null;
        _this.state = {
            autodraw: true,
        };
        _this.drawCard = _this.drawCard.bind(_this);
        _this.pickUpKitty = _this.pickUpKitty.bind(_this);
        _this.revealCard = _this.revealCard.bind(_this);
        _this.onAutodrawClicked = _this.onAutodrawClicked.bind(_this);
        return _this;
    }
    Draw.prototype.drawCard = function () {
        // Must be our turn AND the deck must still have cards. The deck check
        // matters because a previously-armed auto-draw timer can fire just after
        // the deck empties — and now that the "Done bidding" window keeps the draw
        // phase mounted with an empty deck, that stale fire would otherwise send a
        // DrawCard the server rejects with "no cards left in deck".
        var canDraw = this.props.state.propagated.players[this.props.state.position].name ===
            this.props.name && this.props.state.deck.length > 0;
        if (this.timeout !== null) {
            this.props.clearTimeout(this.timeout);
            this.timeout = null;
        }
        if (canDraw) {
            if (this.props.playDrawCardSound) {
                if (this.drawCardAudio === null) {
                    this.drawCardAudio = new Audio("434472_dersuperanton_taking-card.mp3");
                }
                this.drawCardAudio.play();
            }
            window.send({ Action: "DrawCard" });
            // After issuing a draw, the server advances any bots and broadcasts a new
            // state. In a game whose only other players are bots, that broadcast can
            // already have the turn back on us (the bots drew server-side in the same
            // operation), so `canDraw` never flips to false in between. The auto-draw
            // re-arm in render() keys off a false->true transition of `could_draw`, so
            // we must reset it here; otherwise auto-draw fires exactly once and stalls.
            this.could_draw = false;
        }
    };
    Draw.prototype.pickUpKitty = function (evt) {
        evt.preventDefault();
        window.send({ Action: "PickUpKitty" });
    };
    Draw.prototype.revealCard = function (evt) {
        evt.preventDefault();
        window.send({ Action: "RevealCard" });
    };
    Draw.prototype.onAutodrawClicked = function (evt) {
        this.setState({
            autodraw: evt.target.checked,
        });
        if (evt.target.checked) {
            this.drawCard();
        }
        else {
            if (this.timeout !== null) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        }
    };
    Draw.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var canDraw = this.props.state.propagated.players[this.props.state.position].name ===
            this.props.name && this.props.state.deck.length > 0;
        if (canDraw &&
            !this.could_draw &&
            this.timeout === null &&
            this.state.autodraw) {
            this.timeout = this.props.setTimeout(function () {
                _this.drawCard();
            }, this.props.autodrawSpeedMs !== null ? this.props.autodrawSpeedMs : 700);
        }
        this.could_draw = canDraw;
        var next = this.props.state.propagated.players[this.props.state.position].id;
        if (this.props.state.deck.length === 0) {
            // Deck fully drawn: the seat that finalizes bidding (picks up the kitty)
            // is the landlord. This MUST mirror the backend's DrawPhase::next_player
            // exactly. A pinned landlord (every round after the first, and any
            // pre-selected first landlord) takes precedence over the bids; only when
            // no landlord is pinned is the winner resolved from the bids by the
            // configured first-landlord-selection policy.
            //
            // The old code used the last *bidder* unconditionally, which was wrong
            // whenever a landlord was pinned: a human who DECLARED as a NON-landlord
            // looked like the standing winner here, so `isStandingWinner` was true,
            // their "Done bidding" button was hidden, and the game deadlocked — the
            // bot landlord parked forever waiting for a "Done bidding" click the human
            // could never make.
            var landlord_1 = this.props.state.propagated.landlord;
            if (landlord_1 !== null && landlord_1 !== undefined) {
                next = landlord_1;
            }
            else if (this.props.state.bids.length > 0) {
                next =
                    this.props.state.propagated.first_landlord_selection_policy ===
                        "ByFirstBid"
                        ? this.props.state.bids[0].id
                        : this.props.state.bids[this.props.state.bids.length - 1].id;
            }
        }
        var players = {};
        var playerId = -1;
        this.props.state.propagated.players.forEach(function (p) {
            players[p.id] = p;
            if (p.name === _this.props.name) {
                playerId = p.id;
            }
        });
        // The "Done bidding" window is open once the deck is fully drawn and a bid is
        // decided (a real bid or an auto-bid from revealing the bottom). It is offered
        // to every human EXCEPT the current standing (winning) bidder — that player
        // finalizes by picking up the kitty instead. Each human clicks it when
        // satisfied; the landlord is only finalized once every human is done (a new
        // bid re-opens the window and clears the flag server-side).
        var deckDrawn = this.props.state.deck.length === 0;
        var bidDecided = this.props.state.bids.length > 0 || this.props.state.autobid != null;
        var isStandingWinner = playerId >= 0 && next === playerId;
        var showDoneBidding = playerId >= 0 && deckDrawn && bidDecided && !isStandingWinner;
        var isDoneBidding = playerId >= 0 && ((_a = this.props.state.done_bidding) !== null && _a !== void 0 ? _a : []).includes(playerId);
        var landlord = this.props.state.propagated.landlord;
        var trump;
        if (landlord !== null &&
            landlord !== undefined &&
            players[landlord] !== undefined) {
            trump = {
                NoTrump: {
                    number: players[landlord].level !== "NT" &&
                        players[landlord].level !== undefined &&
                        players[landlord].level !== null
                        ? players[landlord].level
                        : null,
                },
            };
        }
        return (React.createElement("div", null,
            React.createElement(Header, { gameMode: this.props.state.game_mode, chatLink: this.props.state.propagated.chat_link }),
            React.createElement(Players, { players: this.props.state.propagated.players, observers: this.props.state.propagated.observers, bots: this.props.state.propagated.bots, landlord: landlord, next: next, name: this.props.name }),
            React.createElement(BidArea, { bids: this.props.state.bids, autobid: this.props.state.autobid, hands: this.props.state.hands, epoch: 0, name: this.props.name, trump: trump, landlord: landlord, players: this.props.state.propagated.players, bidPolicy: this.props.state.propagated.bid_policy, bidReinforcementPolicy: this.props.state.propagated.bid_reinforcement_policy, jokerBidPolicy: this.props.state.propagated.joker_bid_policy, numDecks: this.props.state.num_decks, showDoneBidding: showDoneBidding, isDoneBidding: isDoneBidding, header: React.createElement(React.Fragment, null,
                    React.createElement("h2", { className: "mb-2 text-base font-bold uppercase tracking-wide text-[var(--text-on-felt)]" }, t("bid.remaining", { count: this.props.state.deck.length })),
                    this.props.state.removed_cards.length > 0 ? (React.createElement("p", { className: "text-sm text-[var(--text-on-felt-soft)]" },
                        t("play.removedNote"),
                        " ",
                        this.props.state.removed_cards.map(function (c) { return (React.createElement(InlineCard, { key: c, card: c })); }))) : null), prefixButtons: React.createElement(React.Fragment, null,
                    React.createElement("button", { onClick: function (evt) {
                            evt.preventDefault();
                            _this.drawCard();
                        }, disabled: !canDraw, className: "sj-btn sj-btn-primary" }, t("bid.drawCard")),
                    React.createElement("label", { className: "flex items-center gap-2 text-sm font-medium text-[var(--text-on-felt)]" },
                        React.createElement("input", { type: "checkbox", name: "autodraw", className: "h-4 w-4 accent-[var(--accent)]", checked: this.state.autodraw, onChange: this.onAutodrawClicked }),
                        t("bid.autoDraw"))), suffixButtons: React.createElement(React.Fragment, null,
                    React.createElement("button", { onClick: this.pickUpKitty, disabled: this.props.state.deck.length > 0 ||
                            (this.props.state.bids.length === 0 &&
                                this.props.state.autobid === null &&
                                !(landlord !== null &&
                                    landlord !== undefined &&
                                    ((_b = players[landlord]) === null || _b === void 0 ? void 0 : _b.level) === "NT")) ||
                            (landlord !== null && landlord !== playerId) ||
                            (landlord === null &&
                                ((this.props.state.propagated
                                    .first_landlord_selection_policy === "ByWinningBid" &&
                                    ((_c = this.props.state.bids[this.props.state.bids.length - 1]) === null || _c === void 0 ? void 0 : _c.id) !== playerId) ||
                                    (this.props.state.propagated
                                        .first_landlord_selection_policy === "ByFirstBid" &&
                                        ((_d = this.props.state.bids[0]) === null || _d === void 0 ? void 0 : _d.id) !== playerId))), className: "sj-btn" }, t("bid.pickUpKitty")),
                    React.createElement("button", { onClick: this.revealCard, disabled: landlord === null ||
                            landlord === undefined ||
                            this.props.state.deck.length > 0 ||
                            this.props.state.bids.length > 0 ||
                            this.props.state.autobid !== null ||
                            (this.props.state.revealed_cards || 0) >=
                                this.props.state.kitty.length ||
                            (landlord !== null &&
                                landlord !== undefined &&
                                ((_e = players[landlord]) === null || _e === void 0 ? void 0 : _e.level) === "NT"), className: "sj-btn" }, t("bid.revealCard")),
                    React.createElement(BeepButton, null)), bidTakeBacksEnabled: this.props.state.propagated.bid_takeback_policy ===
                    "AllowBidTakeback" }),
            React.createElement(LabeledPlay, { className: "kitty", cards: this.props.state.kitty, trump: { NoTrump: {} }, label: t("term.kitty") })));
    };
    return Draw;
}(React.Component));
export default Draw;
